import { twMerge } from "tailwind-merge";

export const ChevronIcon: React.FC<{ open: boolean; className?: string }> = ({
  open,
  className,
}) => (
  <span
    className={twMerge(
      "text-grey6 text-[8px] leading-none transition-transform",
      open && "rotate-180",
      className,
    )}
  >
    ▼
  </span>
);
